import { render } from "./PlansSection.vue?vue&type=template&id=072c795c"
import script from "./PlansSection.vue?vue&type=script&lang=js"
export * from "./PlansSection.vue?vue&type=script&lang=js"

import "./PlansSection.vue?vue&type=style&index=0&id=072c795c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__